import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-auth',
  templateUrl: './footer-auth.component.html'
})
export class FooterAuthComponent { }
